var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeasurements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.175L18.59 0.765005L15.74 3.975C13.68 1.655 10.83 0.255005 7.61 0.255005C4.72 0.255005 2.07 1.415 0 3.255L1.42 4.675C3.12 3.185 5.27 2.255 7.61 2.255C10.35 2.255 12.7 3.515 14.38 5.495L11.5 8.735L7.5 4.735L0 12.245L1.5 13.745L7.5 7.735L11.5 11.735L15.55 7.185C16.3 8.535 16.8 10.085 16.99 11.735H19C18.78 9.435 18.05 7.34501 16.96 5.59501L20 2.175Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurements);
export default __webpack_public_path__ + "static/media/Measurements.081bb637b90856e70f8d887195d26ef8.svg";
export { ForwardRef as ReactComponent };